// extracted by mini-css-extract-plugin
module.exports = {"absoluteDiv":"UserList_absoluteDiv__2qiQa","toastStyle":"UserList_toastStyle__3v4gO","DeleteButton":"UserList_DeleteButton__3tygs","EditButton":"UserList_EditButton__2dC8x"};